/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import { useState, Suspense, forwardRef, useContext, useEffect } from "react";
import {
	NexcalEmployeeLogo,
	PhcsLogo,
	QuestDiagonosticLogo,
	BrookshireLogo,
	CPLLogo,
	HealthSmartLogo,
	NexcalLogoPurple,
	ShieldPoweredLOGO
} from "../../../../../assets";
import CustomDataGrid from "../../../../shared/customDataGrid/CustomDataGrid";
import { AuthContext } from "../../../../../contexts";
import { maskSSN } from "../../../../../constants/maskSSN";

import { Grid, Paper } from "@mui/material";
import QRCode from "react-qr-code";
import { getLocalIPV4 } from "../../../../../utils/commonFunctions/getLocalIP4";
import encryption from "../../../../../utils/commonFunctions/encryption";
import { MEMBER_ENV } from "../../../../../config/config";

import "./healthCardPrint.css";
import { Enrollments } from "../../../../../types/enrollment.types";
interface BopHealthPlanPrintProps {
	first_name: string;
	last_name: string;
	_ssn: string;
	group_number: string;
	healthPlanDetails: Enrollments;
}

const BopHealthPlanPrint = forwardRef<HTMLDivElement, BopHealthPlanPrintProps>(
	({ first_name, last_name, _ssn, group_number, healthPlanDetails }, ref) => {
		const [localIP, setLocalIP] = useState("");
		const [urlLink, setUrlLink] = useState("");
		const { member } = useContext(AuthContext);

		// console.log("Member Details55555", member);
		const ssn = maskSSN(_ssn);
		// console.log("_ssn", _ssn);

		useEffect(() => {
			// eslint-disable-next-line arrow-parens
			getLocalIPV4().then((ip) => setLocalIP(ip));
		}, []);

		useEffect(() => {
			const { group_number, date_of_birth, SSN } = member;

			// const localRedirectionLink1 = `http://192.168.1.35:3002/eligibility-check?gn=${group_number}&&qs=${encryption(
			// 	SSN
			// )}&&db=${encryption(date_of_birth)}`;
			// setUrlLink(localRedirectionLink1);
			if (member) {
				// const prodRedirectionLink = `www.nexcaliber.com/eligibility-check?gn=${group_number}&&qs=${encryption(
				// 	SSN
				// )}&&db=${encryption(date_of_birth)}`;

				const prodRedirectionLink = "www.nexcaliber.com/eligibility-check";

				if (member && (MEMBER_ENV === "PROD" || MEMBER_ENV === "DEV")) setUrlLink(prodRedirectionLink);
			}
			if (member && localIP) {
				const localRedirectionLink = `http:${localIP}:3002/eligibility-check?gn=${group_number}&&qs=${encryption(
					SSN
				)}&&db=${encryption(date_of_birth)}`;

				if (member && MEMBER_ENV === "LOCAL") setUrlLink(localRedirectionLink);
			}
		}, [member, localIP]);

		return (
			<div ref={ref}>
				<div className="employee-health-card-container">
					<div className="paper-form-container">
						<Paper
							className="theme-border-radius emp-paper-container employee-print-paper-container"
							elevation={1}
						>
							{/* <Grid container className="card-header-container">
								<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="group-logo">
									<img
										src={HealthSmartLogo}
										alt="Brookshire-logo"
										style={{ width: "8rem", height: "auto", marginTop: "1rem" }}
									/>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9} className="health-card-content">
									<div className="employee-health-card-header">
										<span style={{ fontSize: "1rem" }}>Intercity Investment, Inc.</span>
									</div>

									<div className="employee-health-card-sub-header">
										<span style={{ marginTop: 4 }}>Administrated by Nexcaliber</span>
									</div>
									<div>
										<img
											src={NexcalLogoPurple}
											style={{
												width: "9rem",
												height: "auto",
												marginLeft: "4.8rem",
												marginTop: "0"
											}}
											alt=""
										/>
									</div>
								</Grid>
							</Grid> */}
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									marginTop: -25
								}}
							>
								{/* <img
								src={BOPPanhandleFirstBankLogo}
								alt="Brookshire-logo"
								style={{ width: "11rem", height: "auto" }}
							/> */}
								<h5 style={{ color: "black" }}>Panhandle First Bank - {healthPlanDetails?.sub_plan}</h5>
								<img
									src={PhcsLogo}
									style={{
										width: "5rem",
										height: "auto"
									}}
									alt=""
								/>
							</div>
							<div className="employee-health-border" />
							<Grid container className="bop-employee-card-details-container">
								<div className="left-details-section">
									<div className="grid-item left">
										Administrated By Nexcaliber
										<span>GP 225</span>
									</div>
									<div className="grid-item left">
										Taxes Provided Network:
										<span>PHCS Network</span>
									</div>
									<div>
										<span style={{ fontSize: "10px" }}>
											www.multiplan.com or call for assistance (800) 922-4362
										</span>
									</div>
									<div className="grid-item left">Call Network (800) 741-0185 for assistance</div>
								</div>

								<div className="right-details-section">
									{/* <div> */}
									{/* <QRCode
										size={256}
										style={{
											height: "3rem",
											maxWidth: "100%",
											width: "100%",
											marginBottom: "-0.25rem"
										}}
										// value={"www.nexcaliber.com"}
										value={urlLink}
										fgColor="#4e4e4e"
										bgColor="#ffffff"
									/> */}
									<span
										className="qr-code-container"
										style={{
											position: "relative",
											marginLeft: "1rem",
											marginRight: "1rem"
											// marginTop: "-1.3rem"
											// backgroundColor: "red"
										}}
									>
										<QRCode
											size={256}
											style={{
												height: "4rem",
												maxWidth: "100%",
												width: "100%",
												marginBottom: "-0.25rem",
												marginLeft: "-0.1rem"
											}}
											// value={"www.nexcaliber.com"}
											value={urlLink}
											fgColor="#4e4e4e"
											bgColor="#ffffff"
										/>

										{/* Top-left corner border */}
										<div
											className="corner-border top-left"
											style={{
												position: "absolute",
												top: -5,
												left: -5,
												width: "15px",
												height: "15px",
												borderTop: "2px solid #9c27b0",
												borderLeft: "2px solid #9c27b0"
											}}
										></div>

										{/* Top-right corner border */}
										<div
											className="corner-border top-right"
											style={{
												position: "absolute",
												top: -5,
												right: -5,
												width: "15px",
												height: "15px",
												borderTop: "2px solid #9c27b0",
												borderRight: "2px solid #9c27b0"
											}}
										></div>

										{/* Bottom-left corner border */}
										<div
											className="corner-border bottom-left"
											style={{
												position: "absolute",
												bottom: -6,
												left: -5,
												width: "15px",
												height: "15px",
												borderBottom: "2px solid #9c27b0",
												borderLeft: "2px solid #9c27b0"
											}}
										></div>

										{/* Bottom-right corner border */}
										<div
											className="corner-border bottom-right"
											style={{
												position: "absolute",
												bottom: -6,
												right: -5,
												width: "15px",
												height: "15px",
												borderBottom: "2px solid #9c27b0",
												borderRight: "2px solid #9c27b0"
											}}
										></div>
									</span>
									{/* </div> */}
									<span style={{ textAlign: "center" }}>Scan for Eligibility and benefits</span>
								</div>
							</Grid>
							<div className="employee-health-border" />
							<Grid container className="employee-middle-section-container">
								{/* <div className="employee-detail">Employee ID Number : XXX-XX-{maskSSN(member.SSN)}</div> */}
								<div className="employee-detail">
									Employee ID Number : XXXX-XX-{maskSSN(member.SSN)}
								</div>
								<span>This card is for identification only; it does not guarantee benefit payment</span>
								<div className="employee-detail">
									Employee Name : {member.last_name}, {member.first_name}
								</div>
							</Grid>
							<div className="employee-health-border" />
							<Grid
								container
								className="employee-card-front-footer"
								style={{ display: "flex", justifyContent: "center" }}
							>
								<span
									style={{
										fontWeight: "bold",
										fontSize: "0.9rem",
										textAlign: "center",
										display: "block",
										marginBottom: "0.05rem"
									}}
								>
									Prescription Drug Benefit With Shield
								</span>
								<div className="footer-down-grid">
									<div>
										<span>BIN: 026556</span>
										<br />
										<span>PCN: SHIELD</span>
									</div>
									<div>
										<span>Shield Phone: 877-659-6101</span>
										<br />
										<span>www.shieldpbm.com</span>
									</div>
									<div>
										<img
											src={ShieldPoweredLOGO}
											style={{
												width: "8rem",
												height: "auto",
												paddingTop: "0.5rem"
											}}
											alt="RxValet Logo"
										/>
									</div>
								</div>
							</Grid>
						</Paper>
					</div>
				</div>
				<div className="employee-id-card-backside-container card-content">
					<div className="paper-form-container">
						<Paper
							className="theme-border-radius emp-paper-container employee-print-paper-container"
							elevation={1}
						>
							<div className="card-back-topPortion-container">
								<h2 style={{ fontWeight: 900 }}>Precertification is required</h2>
								<span style={{ fontWeight: 400 }}>
									Call spectrum review services (800) 258-5055 for any required precertification or
									prior approval of services.
								</span>
								<span style={{ fontWeight: 900 }}>
									Failure to percertify will result in a penalty of $300 per incident
								</span>
							</div>

							<div className="footer-border" />

							<div className="card-back-midPortion-container">
								<div className="upper-section">
									<span style={{ color: "black", fontWeight: "bold" }}>
										For Online Claim access visit the Health Plan Portal
									</span>
									<br />
									<span>Webpage address is https://member.enrollment.nexcaliber.com</span>
								</div>
								<div className="footer-border" />

								{/* <div className="footer-top-content-container" style={{ padding: "0.2rem" }}>
								<span
									className="footer-top-sub-content"
									style={{ marginLeft: "4px", fontSize: "0.65rem" }}
								>
									For Assistance locating a PRO provider, call Nexcaliber: (800) 741-0185
								</span>
							</div> */}
							</div>

							{/* <div className="footer-border" /> */}

							<div className="summary-benefits-footer-container">
								<div
									style={{
										textAlign: "center",
										padding: "0 1rem"
									}}
								>
									<h3 style={{ fontWeight: "bold", margin: 0 }}>
										Medical / Enrollment Questions and Verifications
										<br />
										Nexcaliber- (800) 741-0185
									</h3>
								</div>

								<div className="footer-bottom-content" style={{ marginTop: "0.2rem" }}>
									Mail all claims to Nexcaliber: PO Box 802422, Dallas, Texas 75380
								</div>
								<div className="footer-logo-container">
									<img src={NexcalEmployeeLogo} alt="Nexcal employee Logo" />
								</div>
							</div>
						</Paper>
					</div>
				</div>
			</div>
		);
	}
);

export default BopHealthPlanPrint;
